import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentDetailsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { booking, event, razorpayResponse } = location.state || {};

  console.log("booking123",booking ,event)
  const formatSubscriptionConfig = (config) => {
  if (!config) return "";

  const { years, months, days } = config;

  let text = [];

  if (years && years > 0) text.push(`${years} Year${years > 1 ? "s" : ""}`);
  if (months && months > 0) text.push(`${months} Month${months > 1 ? "s" : ""}`);
  if (days && days > 0) text.push(`${days} Day${days > 1 ? "s" : ""}`);

  return text.length > 0 ? text.join(" • ") : "N/A";
};


  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-gray-50">
      <div className="w-full max-w-3xl overflow-hidden bg-white border border-gray-200 shadow-xl rounded-2xl">
        {/* Header */}
       <div className="relative p-8 overflow-hidden text-center bg-orange-600">

  {/* Soft curved top decoration */}
  <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/pw-maze.png')]"></div>

  {/* Username Greeting */}
  {booking?.username && (
    <h2 className="text-xl font-semibold text-white drop-shadow-md">
      Hello, <span className="font-bold">{booking.username}</span> 👋
    </h2>
  )}

  <h1 className="mt-1 text-3xl font-bold text-white md:text-4xl drop-shadow-lg">
    Payment Successful 🎉
  </h1>

  <p className="mt-3 text-lg font-medium text-orange-100">
    Your booking is confirmed — you're all set!
  </p>

  <p className="mt-1 text-sm italic text-orange-200">
    “Yoga is the journey of the self, through the self, to the self.” – Bhagavad Gita
  </p>
</div>

        {/* Event Details */}
        <div className="p-6 border-b border-gray-200">
          <h2 className="mb-4 text-xl font-semibold text-gray-800">
            Event / Service Details
          </h2>
          {/* Header */}


          <div className="grid grid-cols-1 gap-3 text-gray-700 md:grid-cols-2">
           {/* <div>
              <span className="font-medium">Service booked by:</span> {booking?.
username}
            </div> */}
            <div>
              <span className="font-medium">Title:</span> {event?.title || booking?.serviceName}
            </div>
           
            <div>
              <span className="font-medium">Date:</span>{" "}
              {booking?.date
                ? new Date(booking.date).toLocaleDateString()
                : "-"}
            </div>
            <div>
              <span className="font-medium">Time:</span> {booking?.time || "-"}
            </div>
            <div>
              <span className="font-medium">Venue:</span> {event?.venue || booking?.
location}
            </div>
            <div>
              <span className="font-medium">Contact:</span>{" "}
              {event?.contact?.phone} / {event?.contact?.email || "9828381188"}
            </div>
        
          </div>
        </div>

        {/* Booking Details */}
      {!booking?.is_subscription &&  <div className="p-6 border-b border-gray-200 bg-gray-50">
          <h2 className="mb-4 text-xl font-semibold text-gray-800">
            Booking Details
          </h2>
          <div className="grid grid-cols-1 gap-3 text-gray-700 md:grid-cols-2">
            <div>
              <span className="font-medium">Seats Booked:</span>{" "}
              {booking?.seatsBooked}
            </div>
            <div>
              <span className="font-medium">Amount Paid:</span> ₹
              {booking?.amountPaid}
            </div>
          </div>
        </div>}

 {booking?.is_subscription && (
  <div className="p-6 border-b border-gray-200 bg-gray-50">
    <h2 className="mb-4 text-xl font-semibold text-gray-800">
      Subscription Details
    </h2>

    <div className="grid grid-cols-1 gap-3 text-gray-700 md:grid-cols-2">
      <div>
        <span className="font-medium">Seats Booked:</span> {booking?.seatsBooked}
      </div>

      <div>
        <span className="font-medium">Amount Paid:</span> ₹{booking?.amountPaid}
      </div>

      <div className="md:col-span-2">
        <span className="font-medium">Subscription Period:</span>{" "}
        {formatSubscriptionConfig(booking?.subscriptionConfig)}
      </div>

      <div>
        <span className="font-medium">Start Date:</span>{" "}
        {booking?.subscriptionStart}
      </div>

      <div>
        <span className="font-medium">End Date:</span>{" "}
        {booking?.subscriptionEnd}
      </div>
    </div>
  </div>
)}


        {/* Payment Details */}
        {razorpayResponse && (
          <div className="p-6">
            <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Payment Details
            </h2>
            <div className="grid grid-cols-1 gap-3 text-gray-700 md:grid-cols-2">
              <div>
                <span className="font-medium">Payment ID:</span>{" "}
                {razorpayResponse?.razorpay_payment_id}
              </div>
              <div>
                <span className="font-medium">Order ID:</span>{" "}
                {razorpayResponse?.razorpay_order_id}
              </div>
            </div>
          </div>
        )}

        {/* Buttons */}
        <div className="flex flex-col justify-center gap-4 p-6 border-t border-gray-200 md:flex-row">
          <button
            className="w-full px-6 py-3 font-semibold text-white transition bg-orange-600 rounded-lg shadow md:w-auto hover:bg-orange-700"
            onClick={() => window.print()}
          >
            Download Receipt
          </button>

          <button
            className="w-full px-6 py-3 font-semibold text-orange-600 transition border border-orange-600 rounded-lg shadow md:w-auto hover:bg-orange-50"
            onClick={() => navigate("/My_Bookings")}
          >
            Go to my bookings
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsPage;
